"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCallerAccessGrants = exports.getDataAccess = void 0;
var getDataAccess_1 = require("../s3control/getDataAccess");
Object.defineProperty(exports, "getDataAccess", { enumerable: true, get: function () { return getDataAccess_1.getDataAccess; } });
var listCallerAccessGrants_1 = require("../s3control/listCallerAccessGrants");
Object.defineProperty(exports, "listCallerAccessGrants", { enumerable: true, get: function () { return listCallerAccessGrants_1.listCallerAccessGrants; } });
